import ChatBubbleOutlineOutlinedIcon from '@mui/icons-material/ChatBubbleOutlineOutlined';
import SimplePracticeContactWidget from '../../../../../components/SimplePracticeContactWidget';
import { CONTACT_FORM_CONTENT } from '../../constants';
import { Gapper } from '../../../../../ui/utils';
import {
  Wrapper,
  InfoCard,
  InfoCardTitle,
  InfoCardSubtitle,
  InfoCardText,
  InfoCardInner,
  CtaCardInner,
  CtaIconWrap,
  CtaTitle,
  CtaText,
  StyledGapper,
} from './styles';

const ContactForm = () => {
  return (
    <Wrapper id="contact-form">
      <StyledGapper gap={35} styles={{ flexDirection: 'row' }}>
        <InfoCard>
          <InfoCardInner>
            <Gapper gap={30}>
              <InfoCardTitle component="h3">{CONTACT_FORM_CONTENT.INQUIRIES.title}</InfoCardTitle>
              <Gapper gap={20}>
                <InfoCardSubtitle>{CONTACT_FORM_CONTENT.INQUIRIES.subtitle}</InfoCardSubtitle>
                <InfoCardText>{CONTACT_FORM_CONTENT.INQUIRIES.text}</InfoCardText>
              </Gapper>
            </Gapper>
            <Gapper gap={30}>
              <InfoCardTitle component="h3">{CONTACT_FORM_CONTENT.HOURS.title}</InfoCardTitle>
              <InfoCardText>{CONTACT_FORM_CONTENT.HOURS.text}</InfoCardText>
            </Gapper>
          </InfoCardInner>
        </InfoCard>

        <InfoCard id="contact-form-iframe">
          <CtaCardInner>
            <CtaIconWrap>
              <ChatBubbleOutlineOutlinedIcon />
            </CtaIconWrap>
            <CtaTitle component="h3">{CONTACT_FORM_CONTENT.REACH_OUT.title}</CtaTitle>
            <CtaText>{CONTACT_FORM_CONTENT.REACH_OUT.text}</CtaText>
            <SimplePracticeContactWidget
              label={CONTACT_FORM_CONTENT.REACH_OUT.buttonText}
              note={CONTACT_FORM_CONTENT.REACH_OUT.note}
            />
          </CtaCardInner>
        </InfoCard>
      </StyledGapper>
    </Wrapper>
  );
};

export default ContactForm;
